module.exports = __webpack_public_path__ + "media/LandingPageAssets/AppStoreIcon-aa6e36b0.png";